<template>
    <div id="filter-form-create-customer">
        <div class="header__title d-flex justify-content-between align-items-center mt-2 mb-5 border-bottom">
            <h2 style="color:rgba(0, 0, 0, 1)">Cài đặt hiển thị</h2>
        </div>

      <div v-for="(group, groupKey) in fieldGroups" :key="groupKey" class="mb-4">
        <h2 class="mb-2" style="color:rgba(0, 0, 0, 1)">
          {{ group.label }}
          <el-checkbox
            class="ml-2 mb-5"
            :indeterminate="isIndeterminate(groupKey)"
            :value="isAllChecked(groupKey)"
            @change="toggleAll(groupKey, $event)"
          >Tất cả</el-checkbox>
        </h2>
        <hr>
        <el-checkbox-group v-model="selected[groupKey]">
          <el-checkbox
            v-for="field in group.fields"
            :label="field.key"
            :key="field.key"
          >{{ field.label }}</el-checkbox>
        </el-checkbox-group>
      </div>
       <div class="d-flex justify-content-end">
            <el-button @click="handleConfig()" :loading="loadingSave">{{ isUpdateConfig ? 'Sửa thông tin' : 'Lưu thông tin' }}</el-button>
        </div>
    </div>
  </template>

  <script>
  import {SERVICE_CONFIG_CUSTOMER_STORE, SERVICE_CONFIG_CUSTOMER_UPDATE} from "@/core/services/store/service.module";

  export default {
    name: 'FiterFormCreateCustomer',
    props: {
      initialSelected: Object,
      isUpdateConfig: Boolean,
      idConfig: Number,
      is_show: Boolean,
    },
    watch: {
        is_show: {
            handler(val) {
                if (val && this.$route.path.includes('customer/create')) {
                    this.$delete(this.fieldGroups, 'result');
                }
            },
            immediate: true
        }
    },
    computed: {
      selected: {
        get() {
          return this.initialSelected;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    data() {
      return {
        loadingSave: false,
        fieldGroups: {
          basic: {
            label: 'Thông tin cơ bản',
            fields: [
              { key: 'name', label: 'Họ tên' },
              { key: 'phone', label: 'Số điện thoại' },
              { key: 'email', label: 'Email' },
              { key: 'facebook', label: 'Facebook' },
              { key: 'birthday', label: 'Ngày sinh' },
              { key: 'que_quan', label: 'Quê quán' },
              { key: 'address', label: 'Địa chỉ' },
              { key: 'school', label: 'Trường học' },
              { key: 'major', label: 'Ngành học' },
              { key: 'object_customer', label: 'Đối tượng'},
            ]
          },
          parent: {
            label: 'Thông tin phụ huynh',
            fields: [
              { key: 'name', label: 'Họ tên' },
              { key: 'phone', label: 'Số điện thoại' },
              { key: 'origin', label: 'Quê quán' },
              { key: 'job', label: 'Nghề nghiệp' },
              { key: 'opinion', label: 'Ý kiến' },
              { key: 'phone_other', label: 'số điện thoại khác' }
            ]
          },
          potential: {
            label: 'Thông tin khách hàng tiềm năng',
            fields: [
              { key: 'source', label: 'Nguồn' },
              { key: 'hotkey', label: 'Phím nóng' },
              { key: 'solution', label: 'Giải pháp mời hẹn' },
              { key: 'note', label: 'Ghi chú' }
            ]
          },
          result: {
            label: 'Kết quả tư vấn',
            fields: [
              { key: 'result', label: 'Kết quả' },
              { key: 'course_register', label: 'Khoá học muốn đăng ký' },
              { key: 'reason', label: 'Lý do' },
              { key: 'consultant', label: 'Tư vấn viên' },
              { key: 'consultant_phone', label: 'SDT tư vấn viên' },
              { key: 'score', label: 'Điểm test' },
              { key: 'comment', label: 'Nhận xét' },
              { key: 'hotkey_extra', label: 'Phím nóng bổ sung' },
              { key: 'financial_extra', label: 'Tài chính bổ sung' },
              { key: 'decision_extra', label: 'Người ra quyết định' },
              { key: 'problem', label: 'Vấn đề khách hàng sau tư vấn' },
              { key: 'list_contract', label: 'Danh sách hợp đồng' }
            ]
          }
        }
      };
    },
    methods: {
      isAllChecked(groupKey) {
        return this.selected[groupKey]?.length === this.fieldGroups[groupKey]?.fields?.length;
      },
      isIndeterminate(groupKey) {
        const total = this.fieldGroups[groupKey]?.fields?.length;
        const selected = this.selected[groupKey]?.length || 0;
        return selected > 0 && selected < total;
      },
      toggleAll(groupKey, checked) {
        this.$set(
          this.selected,
          groupKey,
          checked ? this.fieldGroups[groupKey].fields.map(f => f.key) : []
        );
      },

      handleConfig() {
        this.loadingSave = true;
        const data = this.initialSelected;
        const formatted = {};

        for (const key in data) {
          if (Array.isArray(data[key])) {
            formatted[key] = data[key];
          }
        }
        this.isUpdateConfig ? this.updateConfig(formatted) : this.saveConfig(formatted);
      },

      updateConfig(formatted) {
        this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_UPDATE, {
          id:this.idConfig,
          detail: formatted,
          config_type: 0,
          model: 'customer'
        })
        .then(() => {
          this.loadingSave = false;
          this.close();
          this.$message.success('Lưu cấu hình thành công');
        });
      },

      saveConfig(formatted) {
        this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_STORE, {
          detail: formatted,
          config_type: 0,
          model: 'customer'
        })
        .then(() => {
          this.loadingSave = false;
          this.close();
          this.$message.success('Lưu cấu hình thành công');
        });
      },

      close() {
        this.$emit('close')
      }
    }
  };
  </script>

  <style>
  #filter-form-create-customer .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  #filter-form-create-customer .el-checkbox__input.is-checked+.el-checkbox__label,
  #filter-form-create-customer .el-checkbox {
    font-family: SVN-Gilroy;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    color: rgba(6, 7, 11, 0.87) !important;
  }

  #filter-form-create-customer .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: rgba(71, 47, 146, 1);
        color: rgba(255, 255, 255, 1);
        border: none;
  }
  #filter-form-create-customer .el-checkbox__inner::after {
    height: 9px;
    left: 5px
  }

  </style>
